import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, CircularProgress } from '@mui/material';
import theme from './theme/theme';
import MainLayout from './layout/MainLayout';
import ScrollToTop from './components/ScrollToTop';

// Lazy load pages for performance
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Platform = lazy(() => import('./pages/Platform'));
const Solutions = lazy(() => import('./pages/Solutions'));
const UseCases = lazy(() => import('./pages/UseCases'));
const Ministries = lazy(() => import('./pages/Ministries'));
const Technology = lazy(() => import('./pages/Technology'));
const Insights = lazy(() => import('./pages/Insights'));
const CaseStudies = lazy(() => import('./pages/CaseStudies'));
const Partners = lazy(() => import('./pages/Partners'));
const Careers = lazy(() => import('./pages/Careers'));
const Contact = lazy(() => import('./pages/Contact'));
const RegisteredUsers = lazy(() => import('./pages/RegisteredUsers'));

const LoadingFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', bgcolor: 'background.default' }}>
    <CircularProgress color="primary" />
  </Box>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router basename="">
        <ScrollToTop />
        <MainLayout>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/platform" element={<Platform />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/use-cases" element={<UseCases />} />
              <Route path="/ministries" element={<Ministries />} />
              <Route path="/technology" element={<Technology />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/registeredUsers" element={<RegisteredUsers />} />
            </Routes>
          </Suspense>
        </MainLayout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
